import React from 'react';

/**
 * Поиск по таблице подбора.
 *
 * Стоит под потребностью, а не среди фильтров: чипы применений отбирают, когда
 * менеджер не знает названия, а поиск — когда знает. Это два разных способа
 * работы, и мешать их в одну строку значит заставлять выбирать между ними на
 * каждом взгляде.
 */
const InsulationPickerSearch = ({ search, onSearchChange }) => (
  <div className="ins-pick__search">
    <label className="ins-pick__filter-title" htmlFor="ins-pick-search">
      Поиск по названию или производителю
    </label>
    <div className="ins-pick__search-field">
      <input
        id="ins-pick-search"
        type="search"
        className="ins-pick__search-input"
        placeholder="например: роквул 100 или технониколь"
        value={search}
        onChange={(event) => onSearchChange(event.target.value)}
      />
      {search ? (
        <button
          type="button"
          className="ins-pick__search-clear"
          onClick={() => onSearchChange('')}
          aria-label="Очистить поиск"
        >
          ×
        </button>
      ) : null}
    </div>
  </div>
);

export default InsulationPickerSearch;
